module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-16.bf2af511.svg";